import { Clock, Info } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "~/components/ui/button";

export function AppointmentType({
  title,
  description,
  duration,
  onClick,
  bookingMode,
  requestHintText,
  registration,
}: Props) {
  const { t } = useTranslation();
  const isRequestMode = bookingMode === "request";

  return (
    <div className="flex flex-col justify-between rounded-[16px] border shadow-md transition-shadow hover:shadow-lg">
      <div className="flex items-center justify-between space-x-3 rounded-t-[16px] bg-blue-550 p-3 text-lg font-bold text-white sm:space-x-4 sm:p-4">
        <h3 className="min-w-0 break-words text-base font-bold sm:text-xl">{title}</h3>
        {duration !== undefined ? (
          <div className="flex shrink-0 items-center space-x-2">
            <Clock className="size-4 sm:size-6" />
            <p className="text-sm">{duration} min</p>
          </div>
        ) : null}
      </div>
      <div className="rounded-b-xl bg-white p-3 sm:p-4">
        <p className="text-sm sm:text-base">{description}</p>
        {isRequestMode && requestHintText ? (
          <div className="mt-3 flex gap-2 rounded-md bg-blue-50 p-3 text-sm text-blue-900">
            <Info className="size-5 flex-shrink-0" />
            <p>{requestHintText}</p>
          </div>
        ) : null}
      </div>
      <div className="w-full px-3 pb-3 pt-1 sm:p-4">
        <Button className="w-full font-bold" onClick={onClick}>
          {registration ? t("Jetzt anmelden") : isRequestMode ? t("Anfrage senden") : t("Jetzt buchen")}
        </Button>
      </div>
    </div>
  );
}

interface Props {
  registration?: boolean;
  title: string;
  description: string | undefined;
  duration: number | undefined;
  onClick: () => void;
  bookingMode?: "direct" | "request";
  requestHintText?: string;
}
